import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import AppHeader from '../components/AppHeader';
import { RouteComponentProps } from 'react-router-dom';

interface RGPDProps
  extends RouteComponentProps<{
    id: string;
  }> {}

const RGPD: React.FC<RGPDProps> = ({ match }) => {
  return (
    <IonPage className="news-single">
      <AppHeader defaultBackLink="/dashboard/" />
      <IonContent>
        <div className="wrapper wrapper--large">
          <div className="ion-padding">
            <div className="ion-text-content">
              <small>
                LE PASS _ CONDITIONS GENERALES D'UTILISATION pour une
                utilisation NON professionnelle Applicables à compter du 30
                novembre 2020
              </small>

              <h2>I. Objet et champ d’application</h2>

              <p>
                {' '}
                Le GIE UNILABS FRANCE (RCS 489 952 796) édite la web application
                LE PASS accessible sur mobile, tablette et ordinateur à
                l’adresse URL https://lepass.unilabs.fr/ (ci-après
                «l’Application») qui a pour objet de permettre à un Patient
                Unilabs : de se préenregistrer avant son arrivée en laboratoire
                en renseignant ses informations personnelles, et/ou d’annoncer
                son arrivée en laboratoire également en renseignant ses
                informations personnelles. Les objectifs de l’Application sont
                d’améliorer le confort du patient et de faciliter la saisie
                administrative des dossiers patients. Dans le cadre de la
                finalisation de l’Application, UNILABS FRANCE a développé un
                pilote de l’Application (ci-après « le Pilote de l’Application »
                ou « le Pilote ») et souhaite désormais le tester directement
                auprès des Patients Unilabs pour leurs analyses de biologie
                médicale dites de routine et/ou les dépistages COVID-19, afin
                d’avoir l’avis des utilisateurs, connaître leurs besoins et
                améliorer les caractéristiques de l’Application. Les présentes
                Conditions Générales d'Utilisation ont pour objet de fixer les
                règles d'utilisation de l’Application et du Pilote de
                l’Application par l'Utilisateur. Ainsi, l'Utilisateur s'engage à
                respecter les présentes Conditions Générales d'Utilisation à
                chacune de ses utilisations du Pilote de l’Application et de
                l’Application dans sa version aboutie. En conséquence,
                l'Utilisateur accepte, pleinement et sans aucune réserve,
                l'ensemble des présentes Conditions Générales d'Utilisation
                avant toute navigation sur l’Application, en cochant la case
                désignant la phrase « Je certifie être majeur(e) et avoir lu et
                accepté les Conditions Générales d’Utilisation de LE PASS»
                située au bas de la page d'inscription pour la valider. UNILABS
                FRANCE est libre de modifier les Conditions Générales
                d'Utilisation à tout moment. Il est donc conseillé à
                l'Utilisateur de se référer, régulièrement, à la dernière
                version des Conditions Générales d'Utilisation disponible en
                permanence à l'adresse suivante :
                https://lepass.unilabs.fr/dashboard/cgu. Les Conditions
                Générales d'Utilisation applicables sont celles en vigueur à la
                date d’utilisation du Pilote de l’Application et de
                l’Application, sous réserve que celles-ci soient accessibles en
                ligne au moment de la navigation dans l’Application.{' '}
              </p>

              <h2>II. DEFINITIONS</h2>

              <p>
                Dans les présentes Conditions Générales d'Utilisation, les mots
                ou expressions commençant avec une majuscule auront la
                signification suivante: L’Application désigne la web application
                LE PASS telle que décrite à l’article I des présentes conditions
                Générales d’Utilisation et accessible à l’adresse URL
                https://lepass.unilabs.fr/dashboard/resume. Compte désigne les
                informations communiquées par l'Utilisateur lors de son
                inscription ou lors d'une connexion, à savoir ses données
                personnelles et médicales nécessaires à l’utilisation de
                l’Application et son Pilote. Cookie désigne un petit fichier
                d'informations qu'un site Web peut envoyer sur le disque dur
                d'un ordinateur personnel pour ensuite en retrouver la trace.
                Données Personnelles désigne les informations et données
                personnelles (i.e données identifiant directement ou
                indirectement une personne physique) en ce compris les données
                médicales, communiquées par l’Utilisateur lors de son
                inscription et dans le cadre de l’utilisation du Pilote de
                l’Application. Identifiants désigne l'identifiant propre de
                l’utilisateur ("login") et le mot de passe de connexion
                ("password") pour toute connexion. Laboratoire Unilabs désigne
                le laboratoire de biologie médicale, membre du GIE UNILABS
                France, auquel le Patient Unilabs recourt pour ses analyses de
                biologie médicale. Les coordonnées du Laboratoire Unilabs sont
                accessibles sur son site Internet. Le Pilote désigne la version
                non encore aboutie de l’Application en phase de test par les
                laboratoires Biolib Saint Loubès et Biolib Galliéni. Patient
                Unilabs désigne toute personne physique recourant aux services
                d’un laboratoire de biologie médicale membre du GIE UNILABS
                France. Site Internet désigne le site Internet www.unilabs.fr
                édité par la société UNILABS FRANCE. UNILABS FRANCE désigne
                l’entité propriétaire de l’ensemble des droits afférents à
                l’Application et son Pilote, et identifiée en tête des présentes
                Conditions Générales d'Utilisation. Utilisateur désigne le
                Patient Unilabs utilisateur de l’Application et/ou son Pilote,
                quelles que soient les modalités de sa connexion à
                l’Application, en ce compris la version Pilote.
              </p>

              <h2>III. DESCRIPTION DU PRODUIT</h2>

              <p>
                L’Utilisateur qui utilise l’Application peut: Créer un compte
                patient en renseignant ses Données Personnelles : Renseigner les
                Données Personnelles d’un proche pour lui organiser un créneau
                horaire de prise en charge dans un Laboratoire Unilabs. Demander
                un créneau horaire de prise en charge dans un Laboratoire
                Unilabs. Consulter la liste des Laboratoires Unilabs. Consulter
                des informations relatives aux Laboratoires Unilabs ou aux actes
                de biologie en général. Annoncer son arrivée dans le Laboratoire
                Unilabs pour être pris en charge en priorité. Transmettre
                directement ses Données Personnelles de l’Application au système
                de gestion de l’information du Laboratoire Unilabs afin de créer
                son dossier.
              </p>

              <p>
                UNILABS FRANCE pourra apporter des améliorations aux services
                listés ci-dessus en fonction notamment des retours des
                Utilisateurs et des Laboratoires Unilabs.{' '}
              </p>

              <p>
                Lors de sa connexion au Pilote de l’Application, l’Utilisateur
                est dûment informé que : le Pilote de l’Application ne dispose
                pas de toutes les fonctionnalités de la version définitive de
                l’Application, et/ou que certaines de ces fonctionnalités ne
                sont pas optimales, et pourront être sujettes à des fortes
                évolutions et améliorations, que le Pilote de l’Application peut
                connaître des dysfonctionnements et des bugs, que l’utilisation
                du Pilote de l’Application peut entraîner des anomalies.
              </p>

              <p>
                En conséquence, l’Utilisateur reconnaît et accepte que UNILABS
                FRANCE est soumis à une obligation de moyen quant à la
                fourniture des services décrits au présent article III.
              </p>
              <h2>IV. ACCES ET UTILISATION</h2>
              <p>
                de l’application 4.1. L’ordinateur et les frais de connexion
                induits par l’utilisation de l’Application sont à la charge
                exclusive de l'Utilisateur. Il appartient à l’Utilisateur de
                prendre toutes les mesures appropriées de façon à protéger ses
                propres données et/ou logiciels contenus dans son ordinateur.
              </p>

              <p>
                4.2. Lors la création de son Compte sur l’Application et/ou de
                son Pilote, l'Utilisateur s'engage à fournir des informations
                vraies, exactes et complètes et donc à les tenir à jour sans
                délais. Dans l'hypothèse où l'Utilisateur fournirait des
                informations fausses, inexactes, périmées ou incomplètes,
                UNILABS FRANCE est en droit de suspendre ou de lui refuser,
                immédiatement et pour le futur, l'accès à tout ou partie de
                l’Application et/ou de son Pilote.
              </p>

              <p>
                4.3. Pour créer son compte, l’Utilisateur devra donner les
                Données Personnelles suivantes: Non médicales : Nom, prénom,
                adresses, date de naissance, email, téléphone, etc Médicales :
                Numéro SS, Carte vitale, Carte Mutuelle, scan ordonnance,
                médecin traitant. Informations parcours SIDEP COVID
              </p>

              <p>
                Sous réserve de la création de son compte, l’Utilisateur pourra
                se connecter à tout moment, à l’aide de ses Identifiants, à
                l’exception des périodes de maintenance. À savoir : 24 heures
                sur 24, 7 jours sur 7.
              </p>

              <p>
                4.4. UNILABS FRANCE accorde à l'Utilisateur un droit de
                consultation, d'utilisation et d'accès aux informations
                présentes sur l’Application, sous réserve qu’il respecte les
                engagements décrits ci-dessous. De manière générale, et sans que
                cette liste puisse être considérée comme exhaustive,
                l'Utilisateur s'engage à : ne télécharger les informations sur
                son équipement que pour un usage exclusivement personnel, non
                marchand et limité dans le temps ; n'imprimer les informations
                téléchargées sur support papier qu'à la condition que les copies
                ainsi constituées fassent l'objet d'un usage exclusivement
                personnel, ce qui exclut notamment toute reproduction à des fins
                professionnelles ou commerciales ou de diffusion en nombre,
                gratuite ou payante ; à ne pas recopier tout ou partie de
                l’Application sur un autre site ou un réseau interne
                d'entreprise ; ne pas reproduire ou résumer la version numérique
                des informations sauf accord écrit et préalable de UNILABS
                FRANCE; ne pas réaliser une revue ou un panorama de presse à
                partir des informations ou photographies signalées comme
                appartenant à un prestataire tiers, ni à réutiliser ces
                informations pour les proposer sur quelque support que ce soit
                en dehors du strict cadre légal de la copie privée ; ne pas
                reproduire, résumer, altérer, modifier, déplacer, retirer,
                remplacer ou rediffuser, sans autorisation écrite et préalable
                de UNILABS FRANCE, le contenu éditorial des informations [texte
                (articles, titre,...) et/ou reproduction (illustrations, photos
                ...)] et/ou le nom, le logo, la marque « UNILABS FRANCE » et/ou
                toute autre information se rapportant aux droits de UNILABS
                FRANCE ; ne pas extraire ou réutiliser, y compris à des fins
                privées, sans autorisation écrite et préalable de UNILABS
                FRANCE, une partie substantielle ou non du contenu des bases de
                données et archives constituées par l’Application; à mettre en
                place des systèmes de contrôle adaptés en fonction des
                évolutions techniques pour éviter tout "piratage" des
                informations et en particulier pour éviter l'utilisation
                illicite ou contraire aux présentes Conditions Générales
                d'Utilisation de toute information de quelque manière et sous
                quelque forme que ce soit ; à informer UNILABS FRANCE dès la
                connaissance d'un " piratage " et en particulier de toute
                utilisation illicite ou non-contractuelle des informations et ce
                quel que soit le mode de diffusion utilisé. La violation de ces
                dispositions impératives soumet l'Utilisateur ainsi que toutes
                les personnes qui y ont participé aux sanctions pénales et
                civiles prévues par la loi.
              </p>

              <p>
                4.5. UNILABS FRANCE concède aux Utilisateurs un droit personnel,
                non exclusif, non cessible et non transférable d’utilisation de
                l’Application et de son Pilote, pendant toute la durée de son
                utilisation et pour le monde entier. Les Utilisateurs ne
                pourront en aucun cas mettre l’Application ou son Pilote à
                disposition d’un tiers, et s’interdit strictement toute autre
                utilisation, en particulier toute adaptation, modification,
                traduction, arrangement, diffusion, ou décompilation.{' '}
              </p>

              <h2>
                V. UTILISATION DES DONNEES PERSONNELLES ET RESPECT DE LA VIE
                PRIVEE{' '}
              </h2>

              <p>
                5.1. L’Utilisateur choisit ses Identifiants. Les Identifiants
                sont personnels et confidentiels, ils sont destinés à réserver
                l'accès de l’Application et/ou de son Pilote aux seuls Patients
                Unilabs, à protéger l'intégrité et la disponibilité de
                l’Application et de son Pilote, ainsi que l'intégrité, la
                disponibilité et la confidentialité des Données Personnelles
                telles que transmises par les Utilisateurs. L'Utilisateur
                s'engage à conserver ses Identifiants secrets et s'interdit de
                les divulguer sous quelque forme que ce soit à des tiers. Les
                Identifiants ne pourront être modifiés que sur demande de
                l’Utilisateur, ou à l'initiative de UNILABS FRANCE sous réserve
                d’en informer préalablement l’Utilisateur. L'Utilisateur est
                entièrement responsable de l'utilisation des Identifiants le
                concernant. Sauf preuve contraire, toute connexion à
                l’Application et/ou à son Pilote, ou transmission de données
                effectuées à partir des Identifiants de l'Utilisateur sera
                réputée avoir été effectuée par ce dernier. A cet égard,
                l'Utilisateur a la possibilité de s'assurer qu'à l'issue de
                chaque session, il peut se déconnecter explicitement. En cas de
                perte, de vol ou de divulgation accidentelle de ses
                Identifiants, l'Utilisateur doit en informer sans délai, le
                Laboratoire Unilabs, par courrier électronique, qui procèdera
                alors à l'annulation dans les meilleurs délais des Identifiants
                de l'Utilisateur. L'Utilisateur devra également réinitialiser
                son mot de passe en suivant la procédure prévue à cet effet dans
                le Pilote et l’Application. Toute perte, vol, détournement ou
                utilisation non autorisée des Identifiants et leurs conséquences
                relèvent de la responsabilité de l'Utilisateur. L'ouverture
                d'une nouvelle session par des Identifiants déjà en cours
                d'utilisation entraînera automatiquement la fermeture de la 1ère
                session ouverte.
              </p>

              <p>
                UNILABS FRANCE a toujours à l’esprit de mener à bien et au mieux
                sa mission, comme l’indique sa devise CARE BIG, et sa culture
                d’entreprise s’attache à protéger ce qui est le plus précieux
                pour les Patients Unilabs, notamment leurs Données Personnelles,
                qui sont toujours entourées du niveau de sécurité le plus élevé
                dans l’entreprise. UNILABS FRANCE applique depuis toujours la
                réglementation en matière de protection des données. La mise en
                œuvre du nouveau règlement de l’UE en matière de protection des
                données – Règlement général de protection des données (RGPD)
                –impose un nouvel ensemble de règles qu’UNILABS FRANCE applique.
              </p>

              <p>
                Les Données Personnelles transmises par chaque Utilisateur,
                notamment au moment de la création de son Compte ou encore de sa
                navigation sur l’Application, sont utilisées à des fins
                médicales par les équipes des laboratoires membres du réseau
                Unilabs France. Les informations concernant le traitement des
                Données Personnelles par ces laboratoires sont accessibles à
                l’adresse unilabs.fr/unilabs-notice-information-patients.
              </p>

              <p>
                Les Données Personnelles sont hébergées par l’hébergeur de
                données de santé des Laboratoires Unilabs.
              </p>

              <p>
                UNILABS FRANCE s’engage à mettre en œuvre les moyens techniques
                appropriés pour assurer la sécurité des Données Personnelles et
                préserver l’intégrité et la confidentialité des Données
                Personnelles contenues dans l’Application. UNILABS FRANCE met en
                place les mesures techniques et organisationnelles de nature (i)
                à empêcher tout accès ou utilisations frauduleuses des Donnée
                Personnelles et (ii) à prévenir toutes pertes, altérations et
                destructions des Données Personnelles.
              </p>

              <p>
                Chaque Utilisateur dispose d'un droit d'opposition, d'accès, de
                rectification des Données Personnelles le concernant. Un
                Utilisateur peut également demander à supprimer ses Données
                Personnelles de l’Application. Chaque Utilisateur peut exercer
                ces droits en écrivant au Laboratoire Unilabs par e-mail. La
                suppression des Données Personnelles de l’Application n’entraîne
                pas la suppression desdites données qui sont hébergées par les
                laboratoires membres du réseau Unilabs France et qui sont
                nécessaires à la gestion des dossiers des Patients Unilabs.{' '}
              </p>

              <h2>VI. PROPRIETE INTELLECTUELLE DE UNILABS FRANCE</h2>

              <p>
                6.1. UNILABS FRANCE est et demeure seule titulaire de l’ensemble
                des droits de propriété intellectuelle portant sur l’Application
                (en ce compris son Pilote et les développements de l’Application
                auxquels il procèdera), sur la structure et le contenu de
                l’Application, et sur toute la technologie développée dans le
                cadre de la création et de la fabrication de ladite Application.
                UNILABS FRANCE est donc seule en mesure de faire protéger ou non
                ses droits de propriété industrielle sur son Application, par un
                brevet ou tout autre titre de propriété intellectuelle, ce que
                l’Utilisateur reconnaît.
              </p>

              <p>
                6.2. L’utilisation de l’Application n'entraîne le transfert
                d'aucun droit de propriété intellectuelle au profit de
                l’Utilisateur. Ainsi, l’Utilisateur s'engage à ne pas utiliser
                le Pilote et/ou l’Application de manière à porter atteinte aux
                droits d’UNILABS FRANCE et à ce que cette utilisation ne
                constitue pas une contrefaçon ou une concurrence déloyale ou
                parasitaire.
              </p>
              <h2>VII. LIMITATION DE RESPONSABILITE UNILABS FRANCE</h2>

              <p>
                ne saurait être tenue responsable de tout dysfonctionnement du
                Pilote et/ou de l’Application, ni de toute interruption et/ou
                bug de l’Application liés à ou résultant d’un cas de force
                majeure, tel que défini par la jurisprudence française. UNILABS
                FRANCE ne saurait être tenue responsable d’un quelconque dommage
                subi au titre de l’utilisation du Pilote et/ou de l’Application
                (i) si ce dommage résulte, en tout ou en partie, de l’action ou
                de l’omission de l’Utilisateur et/ou de tout tiers, (ii) si ce
                dommage est dû à une incompatibilité technique entre les
                équipements de l’Utilisateur et ceux du Pilote et/ou de
                l’Application. UNILABS FRANCE ne saurait être tenue responsable
                d’un dysfonctionnement de l’Application, si celui-ci est dû à
                des facteurs ne dépendant pas du Pilote de l’Application ou de
                l’Application elle-même (tels qu’une défaillance des
                fournisseurs d’accès à Internet etc.). De même, UNILABS FRANCE
                ne sera pas tenue responsable de tout dommage résultant d’une
                défaillance fonctionnelle de l’ordinateur, support de
                l’utilisation de l’Application. Au vu du caractère non abouti du
                Pilote de l’Application, parfaitement connu par l’Utilisateur,
                la responsabilité de UNILABS FRANCE ne saurait être engagée pour
                tout dysfonctionnement inhérent aux risques potentiels
                identifiés à l’article III intitulé « Description du Produit ».
                L'Utilisateur reconnaît utiliser l’Application (en ce compris le
                Pilote) à ses seuls risques et périls. L'Utilisateur admet,
                compte tenu de la nature du Pilote et de l’Application, que
                UNILABS FRANCE peut être amené à modifier sans préavis le
                contenu de l’Application. UNILABS FRANCE pourra proposer des
                liens vers des sites externes à partir de l’Application (en ce
                compris le Pilote), UNILABS France n’est en aucun cas
                responsable des informations figurant sur ces sites et n’a aucun
                contrôle sur ceux-ci.
              </p>
              <h2>VIII. COOKIES</h2>
              <p>
                Certains services personnalisés de l’Application (en ce compris
                le Pilote) peuvent utiliser, pour leur bon fonctionnement, des
                Cookies temporaires et requièrent l'acceptation par
                l'Utilisateur de ces Cookies. Si le navigateur de l'ordinateur
                personnel de l'Utilisateur est configuré pour les refuser,
                l'accès à ces services peut se révéler altéré, voire impossible.
                Les cookies utilisés sur l’Application permettent exclusivement
                de maintenir la connexion à l’Application. L'Utilisateur peut
                désactiver les Cookies ou les supprimer en utilisant les options
                de son navigateur. Chaque navigateur étant différent,
                l'Utilisateur est invité à consulter la notice de son navigateur
                pour le paramétrer à sa convenance. La durée de conservation de
                ces informations dans l'ordinateur de l'Utilisateur est de douze
                (12) mois à compter de leur placement.
              </p>

              <h2> IX. DISPOSITIONS DIVERSES</h2>

              <p>
                9.1. Si l'une quelconque des dispositions des présentes
                Conditions Générales d'Utilisation était déclarée nulle ou
                inapplicable en application d'une loi, d'un règlement ou à la
                suite d'une décision de justice devenue définitive, elle serait
                réputée non écrite et les autres dispositions resteraient en
                vigueur.
              </p>

              <p>
                9.2. Les relations contractuelles entre UNILABS FRANCE et
                l’Utilisateur sont régies par les dispositions des présentes
                Conditions Générales d'Utilisation et par la règlementation
                applicable à la relation entre un patient et un laboratoire
                d’analyses de biologie médicale.
              </p>

              <p>
                9.3. L'Utilisateur ne peut pas céder tout ou partie des droits
                et obligations résultant des Conditions Générales d’Utilisation.
              </p>

              <h2>X. LOI APPLICABLE ET ATTRIBUTION DE JURIDICTION</h2>

              <p>
                10.1. Les présentes Conditions Générales d'Utilisation sont
                soumises à tous égards au droit français. Elles ont été rédigées
                en langue française qui sera considérée, en toute hypothèse,
                comme la langue unique.
              </p>

              <p>
                10.2. Les parties conviennent de faire leur possible pour
                résoudre à l'amiable toute contestation susceptible de résulter
                de l'interprétation, de l'exécution et/ou de la cessation des
                présentes Conditions Générales d'Utilisation. A défaut, ladite
                contestation sera soumise à la compétence exclusive des
                juridictions compétentes du ressort de la Cour d’appel de Paris,
                même en cas de demande incidente ou en garantie ou de pluralité
                de défendeurs.
              </p>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default RGPD;
